import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import Sidebar from '../../../../shared/components/Sidebar';
import './WelcomeScreen.css';

const RoleNotSupportedScreen = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/welcome');
  };

  return (
    <div className="welcome-screen">
      <Sidebar>
        <div className="welcome-sidebar-content">
          <button
            className="back-button"
            onClick={handleBack}
            aria-label="Back to role selection"
          >
            <FaArrowLeft className="back-icon" />
          </button>
        </div>
      </Sidebar>
      <div className="welcome-main">
        <div className="welcome-card">
          <div className="welcome-gradient-header"></div>
          <div className="welcome-card-content">
            <h1 className="welcome-title">Role Not Yet Supported</h1>
            <p className="welcome-message">
              We don't have your role yet, but we're working on it! We're continuously adding new roles and frameworks to help you succeed.
            </p>
            <div className="welcome-placeholder-section">
              <p className="welcome-placeholder-label">Explanation (placeholder text for you to copy):</p>
              <textarea
                className="welcome-placeholder-textarea"
                readOnly
                value="We're expanding our role-based frameworks and will be adding support for your role soon. In the meantime, you can still access our universal frameworks for Communication and Professional Development."
                rows={6}
              />
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .welcome-sidebar-content .back-button {
          width: auto;
          height: auto;
          min-width: auto;
          min-height: auto;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background: transparent;
          display: flex;
          align-items: start;
          justify-content: start;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #000000;
          padding: 0;
          margin: 0;
          align-self: flex-start;
          box-sizing: border-box;
        }

        .welcome-sidebar-content .back-button:hover {
          color: rgba(0, 0, 0, 0.7);
          border: none !important;
          outline: none !important;
        }

        .welcome-sidebar-content .back-icon {
          font-size: 24px;
          display: block;
          color: #000000;
        }
      `}</style>
    </div>
  );
};

export default RoleNotSupportedScreen;

